import React, {Component} from 'react';
import {arrayOf, func, node, string} from 'prop-types';
import {default as TextInput} from '@sinclair-digital/sbg-storyline-components/src/components/forms/TextInput';
import {default as Icon} from '@sinclair-digital/sbg-storyline-components/src/components/Icon';
import classNames from 'classnames';
import {plus} from 'react-icons-kit/fa/plus';
import styles from './TagCloud.scss';

class TagCloud extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tagInputState: '',
        };
    }

    static propTypes = {
        children: node,
        className: string,
        inputClassName: string,
        tags: arrayOf(node).isRequired,
        placeholder: string.isRequired,
        addTag: func.isRequired,
    };

    static defaultProps = {
        children: undefined,
        className: '',
        inputClassName: '',
        tags: [],
    };

    onAddTag = () => {
        this.props.addTag(this.state.tagInputState);
        this.setState({tagInputState: ''});
    };

    onKeyDown = ({key}) => {
        if (key === 'Enter') {
            this.onAddTag(this.state.tagInputState);
            this.setState({tagInputState: ''});
        }
    };

    onInputChange = ({target: {value}}) => {
        this.setState({tagInputState: value});
    };

    renderTags = (tag, i) => {
        return (
            <div key={i} className={styles.tags}>
                {tag}
            </div>
        );
    };

    render() {
        const {className, inputClassName, tags} = this.props;
        return (
            <div className={classNames(className, styles.TagCloud)}>
                <div className={styles.row}>
                    <div className={classNames(inputClassName, styles.inputGroup)}>
                        <TextInput
                            className="sda-input-text-full"
                            name="included"
                            onKeyDown={this.onKeyDown}
                            type="text"
                            theme="default"
                            onChange={this.onInputChange}
                            value={this.state.tagInputState}
                            maxLength="256"
                            placeholder={this.props.placeholder}
                        />

                        {this.props.children}

                        <div
                            onClick={this.onAddTag}
                            onKeyPress={this.enterKeyHandler}
                            className={classNames('sda-btn-icon', styles.plusBtn)}>
                            <Icon icon={plus} />
                        </div>
                    </div>
                </div>
                <div className={styles.tagList}>{tags.map(this.renderTags)}</div>
            </div>
        );
    }
}

export default TagCloud;
